module.exports = __webpack_public_path__ + "static/media/puzzle-34-bg.9e9906cb.svg";